export class RequestError extends Error {
  public statusCode: number;

  public statusText: string;

  public requestInfo: Response;

  public stack: string | undefined;

  public data: unknown;

  public constructor(response: Response, message?: string, data?: unknown) {
    super(message);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, RequestError);
    }

    this.name = 'RequestError';
    this.statusCode = response.status;
    this.statusText = response.statusText;
    this.requestInfo = response;
    this.data = data;
  }
}
